import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitArrayValue'
})
export class LimitArray implements PipeTransform {


  //limit  array for desired length
  transform(value:any, limit:number, state=false) {

    if(value){
        if(!state){
          return value.slice(0,limit)
        }else{
          return value;
        }
    }
    
  }
}